module.exports = "/virtual-football-league/img/amblems/left/logos/Manchester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Manchester.png
// module id = 2110
// module chunks = 4